import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeliveryOverviewWrapperComponent } from './delivery-overview-wrapper/delivery-overview-wrapper.component';

const routes: Routes = [
  {
    path: '',
    component: DeliveryOverviewWrapperComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeliveryOverviewAppRouterModule {}
